import { RemoteDeletePhoto } from 'data/usecases';
import { makeApiUrlPhoto } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteDeletePhoto = (): RemoteDeletePhoto => {
  return new RemoteDeletePhoto(makeApiUrlPhoto(), makeAxiosHttpClient());
};
